import React from "react"
import PropTypes from "prop-types"
import { Container, Heading } from "./styles"
import { H2 } from "../typography"
import Markdown from "../markdown"

const FeatureContent = ({ heading, content, inlineOnMobile, ...rest }) => {
  if (!heading && !content) return null
  if (heading && heading.length == 0 && content && content.length == 0) return null

  return (
    <Container inlineOnMobile={inlineOnMobile} className="ho-feature" {...rest}>
      {heading && (
        <H2 marginless>
          <Heading>{heading}</Heading>
        </H2>
      )}
      <Markdown componentStyles={{ h1: { variant: "primary" } }}>{content}</Markdown>
    </Container>
  )
}

FeatureContent.propTypes = {
  content: PropTypes.string.isRequired,
  heading: PropTypes.string
}

FeatureContent.defaultProps = {
  inlineOnMobile: false
}

export default FeatureContent
